// Tarea 6 — catalogo de las 25 claves de timetracking_settings, espejo de
// Services/SettingsCatalog.cs en el backend. Separado de SettingsModal.js para
// que el componente solo se ocupe de render/estado, no de que campos existen.
//
// Tipos: 'time' (HH:mm), 'integer', 'decimal', 'emails' (chips), 'dates' (chips
// yyyy-MM-dd). Las validaciones aqui son la primera barrera (UX inmediata);
// el backend vuelve a validar contra SettingsCatalog antes de guardar.

export const GRUPO_JORNADA = 'Jornada';
export const GRUPO_AVISOS = 'Avisos';
export const GRUPO_PRECIOS = 'Precios';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const FECHA_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const settingsSchema = [
    // Jornada
    { key: 'JornadaHorasPorDia', label: 'Horas por dia', group: GRUPO_JORNADA, type: 'integer', min: 0, max: 24, unit: 'h' },
    { key: 'ExtrasHorasPorDia', label: 'Horas extra por dia', group: GRUPO_JORNADA, type: 'integer', min: 0, max: 24, unit: 'h' },
    { key: 'JornadaDiasPorSemana', label: 'Dias laborables por semana', group: GRUPO_JORNADA, type: 'integer', min: 1, max: 7 },
    { key: 'ExtrasHorasSabado', label: 'Horas extra el sabado', group: GRUPO_JORNADA, type: 'integer', min: 0, max: 24, unit: 'h' },
    { key: 'JornadaInicio', label: 'Hora de inicio de jornada', group: GRUPO_JORNADA, type: 'time' },
    { key: 'JornadaFin', label: 'Hora de fin de jornada', group: GRUPO_JORNADA, type: 'time' },
    { key: 'ComidaInicio', label: 'Hora de inicio de la comida', group: GRUPO_JORNADA, type: 'time' },
    { key: 'ComidaFin', label: 'Hora de fin de la comida', group: GRUPO_JORNADA, type: 'time' },
    { key: 'ExtrasInicio', label: 'Hora de inicio de horas extra', group: GRUPO_JORNADA, type: 'time' },
    { key: 'ExtrasFin', label: 'Hora de fin de horas extra', group: GRUPO_JORNADA, type: 'time' },
    { key: 'JornadaSabadoInicio', label: 'Hora de inicio de jornada (sabado)', group: GRUPO_JORNADA, type: 'time' },
    { key: 'JornadaSabadoFin', label: 'Hora de fin de jornada (sabado)', group: GRUPO_JORNADA, type: 'time' },

    // Avisos
    { key: 'AvisoNoIniciadoLV', label: 'Aviso: no ha fichado (lunes a viernes)', group: GRUPO_AVISOS, type: 'time' },
    { key: 'AvisoNoIniciadoSabado', label: 'Aviso: no ha fichado (sabado)', group: GRUPO_AVISOS, type: 'time' },
    { key: 'AvisoNoCerradoAntesComida', label: 'Aviso: no ha cerrado antes de comer', group: GRUPO_AVISOS, type: 'time' },
    { key: 'AvisoNoIniciadoDespuesComida', label: 'Aviso: no ha fichado despues de comer', group: GRUPO_AVISOS, type: 'time' },
    { key: 'AvisoNoCerradoFinJornadaLV', label: 'Aviso: no ha cerrado al fin de jornada (L-V)', group: GRUPO_AVISOS, type: 'time' },
    { key: 'AvisoNoCerradoFinJornadaSabado', label: 'Aviso: no ha cerrado al fin de jornada (sabado)', group: GRUPO_AVISOS, type: 'time' },
    { key: 'MinutosMargenSinFichar', label: 'Margen de hueco sin fichar', group: GRUPO_AVISOS, type: 'integer', min: 1, max: 240, unit: 'min' },
    { key: 'AvisoCooldownHuecoMinutos', label: 'Repetir aviso de hueco cada', group: GRUPO_AVISOS, type: 'integer', min: 1, max: 1440, unit: 'min' },
    { key: 'AvisoIntervaloComprobacionMinutos', label: 'Intervalo de comprobacion', group: GRUPO_AVISOS, type: 'integer', min: 1, max: 1440, unit: 'min' },
    { key: 'AvisoDiasNoLaborables', label: 'Dias no laborables (festivos)', group: GRUPO_AVISOS, type: 'dates' },
    { key: 'DestinatariosAvisos', label: 'Destinatarios de los avisos', group: GRUPO_AVISOS, type: 'emails' },

    // Precios
    { key: 'ManoObraPrecio', label: 'Precio de mano de obra', group: GRUPO_PRECIOS, type: 'decimal', min: 0, unit: '€/hora' },
    { key: 'ManoObraPrecioCoste', label: 'Coste de mano de obra', group: GRUPO_PRECIOS, type: 'decimal', min: 0, unit: '€/hora' },
];

export const GRUPOS_ORDEN = [GRUPO_JORNADA, GRUPO_AVISOS, GRUPO_PRECIOS];

export function findDefinition(key) {
    return settingsSchema.find((s) => s.key === key);
}

// Valida un valor de texto (tal como llega de un <input>) contra su
// definicion. Devuelve null si es valido, o un mensaje de error legible.
export function validateValue(def, value) {
    if (def.type === 'time') {
        if (!/^\d{2}:\d{2}$/.test(value)) return `${def.label}: hora invalida.`;
        return null;
    }
    if (def.type === 'integer') {
        if (value === '' || value === null || value === undefined) return `${def.label}: obligatorio.`;
        const n = Number(value);
        if (!Number.isInteger(n)) return `${def.label}: debe ser un numero entero.`;
        if (def.min !== undefined && n < def.min) return `${def.label}: no puede ser menor que ${def.min}.`;
        if (def.max !== undefined && n > def.max) return `${def.label}: no puede ser mayor que ${def.max}.`;
        return null;
    }
    if (def.type === 'decimal') {
        if (value === '' || value === null || value === undefined) return `${def.label}: obligatorio.`;
        const n = Number(value);
        if (Number.isNaN(n)) return `${def.label}: debe ser un numero.`;
        if (def.min !== undefined && n < def.min) return `${def.label}: no puede ser menor que ${def.min}.`;
        return null;
    }
    // emails/dates se validan chip a chip al añadirlos, no como bloque.
    return null;
}

export function isValidEmail(value) {
    return EMAIL_REGEX.test(value.trim());
}

export function isValidFecha(value) {
    return FECHA_REGEX.test(value.trim());
}

// timetracking_settings guarda listas como CSV (mismo formato que usaba
// NotifyEmail en produccion, editable a mano en SSMS sin escapes de JSON).
export function csvToList(value) {
    if (!value) return [];
    return value.split(',').map((v) => v.trim()).filter((v) => v.length > 0);
}

export function listToCsv(list) {
    return list.join(',');
}
